<!-- 解决方案 -->
<template>
	<div class="system-container" v-if="!active">
		<section>
			<article>
				<div class="panel" v-for="(item,index) in systemList" :key="index">
					<img :src="item.img" alt class="image" />
					<div class="content">
						<div class="label">{{ item.name }}</div>
						<p class="text" :title="item.des">{{ item.des }}</p>
					</div>
					<div class="link" @click="active = item.page">
						<div>
							查看详情
							<i class="el-icon-right"></i>
						</div>
						<div class="line"></div>
					</div>
				</div>
				<!--移动端适配 -->
				<div class="mobile-panel" v-for="(item,index) in systemList" :key="index">
					<div class="head">
						<div class="label">{{ item.name }}</div>
						<div class="link" @click="active = item.page">
							查看详情
							<i class="el-icon-right"></i>
						</div>
					</div>
					<p class="text">{{ item.des }}</p>
					<img :src="item.img" alt class="image" />
				</div>
			</article>
		</section>
	</div>
	<div class="component" ref="component" v-else>
		<div class="circle return" title="返回" @click="handleReturn">
			<i class="iconfont iconfontfanhui"></i>
		</div>
		<div class="circle top" title="回到顶部" @click="pageToTop(true)" v-show="showTop">
			<i class="iconfont el-icon-caret-top"></i>
		</div>
		<component :is="active"></component>
	</div>
</template>

<script>
	import highwaySafety from './highwaySafety/highwaySafety';
	import freewayMaintain from './freewayMaintain/freewayMaintain';
	import surveillanceAI from './surveillanceAI/surveillanceAI';
	import freewayDecision from './freewayDecision/freewayDecision';
	import normalRoadMaintain from './normalRoadMaintain/normalRoadMaintain';
	import ruralRoadBigData from './ruralRoadBigData/ruralRoadBigData';
	import roadAIMaintain from './roadAIMaintain/roadAIMaintain';
	import ruralRoadAutoDetection from './ruralRoadAutoDetection/ruralRoadAutoDetection';

	export default {
		props: {
			titleText: {
				type: String,
				default: ''
			},
			headerBackground: {
				type: String,
				default: ''
			}
		},
		components: {
			highwaySafety,
			freewayMaintain,
			surveillanceAI,
			freewayDecision,
			normalRoadMaintain,
			ruralRoadBigData,
			roadAIMaintain,
			ruralRoadAutoDetection
		},
		name: 'prescription',
		data() {
			return {
				timer: null,
				active: null,
				showTop: false,
				systemList: [{
						name: '公路安全设施监测感知报警系统',
						page: 'highwaySafety',
						img: require('@/assets/image/choiceYC/successCase/bg_07.jpg'),
						des: `公路安全设施监测感知报警系统设备适用于桥梁水毁、灾毁、滑坡、泥石流灾害、车船撞击等多种场景的感知报警，如地质灾害易发区、跨线桥、大曲率匝道、事故易发区...`
					}, {
						name: '道路AI智能养护巡查系统',
						page: 'roadAIMaintain',
						img: require('@/assets/image/prescription/roadAIMaintain.png'),
						des: `道路AI智能巡检系统对巡检车进行轻量级改装后，通过车辆巡检，利用先进的AI视...`
					}, {
						name: '高速公路视频监控AI智能监测平台',
						page: 'surveillanceAI',
						img: require('@/assets/image/choiceYC/successCase/bg_08.jpg'),
						des: `随着高速公路里程和车流量的增加，传统视频监控系统已无法满足实时监测和预警的需求。为提升高速公路安全管理水平，需将AI技术融入视频监控系统，赋予传统摄像头...`
					},{
						name: '高速公路养护管理系统',
						page: 'freewayMaintain',
						img: require('@/assets/image/prescription/freewayMaintain.png'),
						des: `高速公路养护管理平台，以“可视化驾驶舱、基础数据管理、技术状况评定、养护决策分析、巡检养护、施工考核、计量支付、合同及安全管理”为核心，实现了从基础数据管理...`
					},
					{
						name: '高速公路养护决策分析系统',
						page: 'freewayDecision',
						img: require('@/assets/image/prescription/freewayDecision.png'),
						des: `平台关键技术包括可视化驾驶舱、基础数据管理、路产管理、桥涵构造物评价、公...`
					},
					{
						name: '普通公路养护管理系统',
						page: 'normalRoadMaintain',
						img: require('@/assets/image/prescription/normalRoadMaintain.png'),
						des: `普通公路巡查养护管理系统主要采用APP上报及AI智能巡检两种方式，目前由我公司...`
					},
					{
						name: '农村公路大数据云平台',
						page: 'ruralRoadBigData',
						img: require('@/assets/image/prescription/ruralRoadBigData.png'),
						des: `农村公路已基本形成遍布农村、连接城乡的农村公路网络，在给我们带来便捷的同时...`
					},
					{
						name: '农村公路自动化检测服务',
						page: 'ruralRoadAutoDetection',
						img: require('@/assets/image/prescription/ruralRoadAutoDetection.png'),
						des: `根据交通运输部和财政部《关于进一步加强农村公路技术状况检测评定工作的通知》...`
					}
				]
			};
		},
		watch: {
			active: {
				handler() {
					let curr = this.systemList.find(item => item.page === this.active);
					if (curr) {
						this.$bus.$emit('changePageTitleAndBackground', {
							page: {
								title: curr.name,
								bg: curr.page
							},
							isChild: true
						});
					}
					this.pageToTop();
				}
			},
		},
		//刷新或通过URL地址进入页面时，同步背景图和标题
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.$nextTick(() => {
					vm.$bus.$emit('changePageTitleAndBackground', {
						page: 'prescription'
					});
				});
			});
		},
		mounted() {
			document.querySelector('#app').addEventListener('scroll', this.isShowTopButton);
			//选择解决方案
			this.$bus.$on('selectSystem', page => this.active = page);
		},
		beforeDestroy() {
			document.querySelector('#app').removeEventListener('scroll', this.isShowTopButton);
		},
		methods: {
			//返回
			handleReturn() {
				this.active = null;
				this.$bus.$emit('changePageTitleAndBackground', {
					page: 'prescription'
				});
				this.pageToTop();
			},

			//滚动到顶部
			pageToTop(isSmooth = false) {
				document.querySelector('.header-bg').scrollIntoView({
					behavior: isSmooth ? 'smooth' : undefined,
					block: 'start'
				});
			},

			//回到顶部按钮显示控制
			isShowTopButton() {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					let el = this.$refs.component;
					if (el) {
						let {
							top
						} = el.getBoundingClientRect();
						this.showTop = top < -400;
					}
				}, 200);
			}
		},

	}
</script>

<style lang='scss' scoped>
	.system-container {
		height: 100%;
		width: 100%;

		section {
			padding: 100px 0;

			.title {
				text-align: center;
				font-size: 36px;
			}

			article {
				margin: 0 auto 80px auto;
				width: 1200px;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-template-rows: repeat(2, 1fr);
				grid-gap: 30px;

				.mobile-panel {
					display: none;
				}

				.panel {
					box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
					position: relative;
					border-radius: 4px;

					&:hover {
						.image {
							transform: translateY(-20px);
						}

						.content {
							transform: translateY(-20px);

							.text {
								-webkit-line-clamp: 5;
							}
						}
					}

					.image {
						height: 250px;
						width: 100%;
						object-fit: fill;
						transition: all 0.2s ease-in-out;
					}

					.content {
						height: 190px;
						box-sizing: border-box;
						width: 100%;
						padding: 0 20px 30px 20px;
						transition: all 0.2s ease-in-out;

						.label {
							margin-top: 30px;
							font-size: 20px;
							font-weight: bold;
						}

						.text {
							margin-top: 30px;
							text-align: justify;
							color: #999999;
							display: -webkit-box;
							line-height: 24px;
							-webkit-line-clamp: 3;
							-webkit-box-orient: vertical;
							overflow: hidden;
						}
					}

					.link {
						bottom: 27px;
						left: 20px;
						position: absolute;
						cursor: pointer;
						font-size: 16px;
						color: #1890ff;

						&:hover {
							.line {
								width: 80px;
							}
						}

						&:active {
							color: #1580e4;
						}

						.line {
							margin-top: 4px;
							width: 0;
							height: 2px;
							background-color: #1890ff;
							transition: all 0.2s ease-in-out;
						}
					}
				}
			}
		}
	}

	.component {
		position: relative;

		.circle {
			cursor: pointer;
			position: fixed;
			border-radius: 50%;
			box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
			padding: 10px;
			color: #409eff;
			right: 64px;
			z-index: 3;

			background-color: #ffffff;

			&:hover {
				background-color: #f2f6fc;
			}

			.iconfont {
				font-size: 20px;
			}
		}

		.return {
			margin-top: 32px;
		}

		.top {
			margin-top: 108px;
		}
	}

	@import "./style.scss";
</style>